/**
 * QUANTO cada linha do trilho mede — para o trilho nunca precisar de rolagem.
 *
 * O tamanho era fixo em 38px e a lista rolava quando não cabia: onze linhas mais
 * três títulos, a paleta, o sino e a conta somam ~695px, e num notebook de 720
 * com barra de favoritos o último lugar ficava fora da tela, sem barra visível
 * (ela é escondida de propósito — barra clara na única superfície escura da mesa
 * é mancha) e sem nada dizendo que havia mais. Trilho é o MAPA do escritório:
 * mapa com pedaço escondido não é mapa.
 *
 * Então ele encolhe em vez de rolar. Duas alavancas, nesta ordem — primeiro a
 * altura da linha (38 → 30, que ainda é alvo confortável de ponteiro; o dedo não
 * chega aqui, no celular a navegação é a barra de abas), e só depois, se ainda
 * não couber, os TÍTULOS dos grupos, que somem deixando o fio separador: o fio
 * já é o que separa os grupos com a coluna fechada, e o nome do grupo é a coisa
 * menos lida da coluna.
 *
 * Abaixo de tudo isso (uma janela de 400px de altura) a rolagem continua ali
 * como último recurso — encolher a linha até 20px seria trocar rolagem por
 * ilegibilidade.
 */
const ITEM_MAX = 38;
const ITEM_MIN = 30;
const TITULO_DO_GRUPO = 28;

export function densidadeDoTrilho(altura, quantosItens, quantosGrupos, noRodape = 0) {
  /* O que não é lista: marca (52), o respiro da paleta (8), o rodapé (18 de
     borda e respiro) e uma folga de 8 para o arredondamento. A paleta e a conta
     medem UMA LINHA cada — por isso entram no divisor, e não no `fora`.
     `noRodape` existe para quem ainda desenhar linha no pé; hoje Notificações,
     Ajustes e Ajuda são itens do MENU da conta, e não custam altura nenhuma. */
  const fora = 52 + 8 + 18 + 8;
  const linhas = quantosItens + 2 + noRodape;
  const cabe = (titulo) => Math.floor((altura - fora - quantosGrupos * titulo - (quantosItens + quantosGrupos) * 2) / linhas);

  const comTitulo = cabe(TITULO_DO_GRUPO);
  if (comTitulo >= ITEM_MAX) return { item: ITEM_MAX, titulo: TITULO_DO_GRUPO };
  /* 32 é o piso para MANTER os títulos: abaixo disso vale mais tirar três
     rótulos do que apertar onze alvos. */
  if (comTitulo >= 32) return { item: comTitulo, titulo: TITULO_DO_GRUPO };
  const semTitulo = cabe(0);
  return { item: Math.max(ITEM_MIN, Math.min(ITEM_MAX, semTitulo)), titulo: 0 };
}
